import React from 'react';
import { useStateList } from '@nile/components/src/Constants/stateslist/getstates';

function StateCountryLabel(props) {
  const { stateCode, countryCode } = props;
  const states = useStateList(stateCode ? 'states' : 'country');
  const currentState = stateCode
    ? states.find(
        (st) => st.isoCode === stateCode && st.countryCode === countryCode
      )?.name || ''
    : states.find((st) => st.isoCode === countryCode)?.name || '';
  return <div>{currentState}</div>;
}

export default StateCountryLabel;
